// extracted by mini-css-extract-plugin
export default {"centeredBox":"styles_centeredBox__VSFov","heading":"styles_heading__oNAD0","description":"styles_description__eAMIP","italicGreyText":"styles_italicGreyText__nUS0E"};